import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _460777ab = () => interopDefault(import('../../../pages/utility/index.vue' /* webpackChunkName: "pages/utility/index" */))
const _56c81db4 = () => interopDefault(import('../../../pages/portal/down-for-maintenance/index.vue' /* webpackChunkName: "pages/portal/down-for-maintenance/index" */))
const _3057b734 = () => interopDefault(import('../../../pages/portal/find-company/_slug/index.vue' /* webpackChunkName: "pages/portal/find-company/_slug/index" */))
const _963b7e12 = () => interopDefault(import('../../../pages/portal/my-companies/_slug/index.vue' /* webpackChunkName: "pages/portal/my-companies/_slug/index" */))
const _c7df7896 = () => interopDefault(import('../../../pages/portal/find-company/_slug/add.vue' /* webpackChunkName: "pages/portal/find-company/_slug/add" */))
const _7415d377 = () => interopDefault(import('../../../pages/portal/find-company/_slug/confirmcompanyadded.vue' /* webpackChunkName: "pages/portal/find-company/_slug/confirmcompanyadded" */))
const _4ac7700e = () => interopDefault(import('../../../pages/portal/find-company/_slug/declaration.vue' /* webpackChunkName: "pages/portal/find-company/_slug/declaration" */))
const _bfafd8ac = () => interopDefault(import('../../../pages/portal/find-company/_slug/faq.vue' /* webpackChunkName: "pages/portal/find-company/_slug/faq" */))
const _18a12600 = () => interopDefault(import('../../../pages/portal/find-company/_slug/find-company-account-created.vue' /* webpackChunkName: "pages/portal/find-company/_slug/find-company-account-created" */))
const _4981fc40 = () => interopDefault(import('../../../pages/portal/find-company/_slug/login/index.vue' /* webpackChunkName: "pages/portal/find-company/_slug/login/index" */))
const _23020432 = () => interopDefault(import('../../../pages/portal/find-company/_slug/select-business-type.vue' /* webpackChunkName: "pages/portal/find-company/_slug/select-business-type" */))
const _b43d5e34 = () => interopDefault(import('../../../pages/portal/find-company/_slug/success-email.vue' /* webpackChunkName: "pages/portal/find-company/_slug/success-email" */))
const _7835b43a = () => interopDefault(import('../../../pages/portal/find-company/_slug/support.vue' /* webpackChunkName: "pages/portal/find-company/_slug/support" */))
const _a994d7d6 = () => interopDefault(import('../../../pages/portal/find-company/_slug/verify.vue' /* webpackChunkName: "pages/portal/find-company/_slug/verify" */))
const _4ee40a3d = () => interopDefault(import('../../../pages/portal/find-company/_slug/login/resend.vue' /* webpackChunkName: "pages/portal/find-company/_slug/login/resend" */))
const _7f42b77b = () => interopDefault(import('../../../pages/portal/find-company/_slug/login/verify.vue' /* webpackChunkName: "pages/portal/find-company/_slug/login/verify" */))
const _912e525e = () => interopDefault(import('../../../pages/portal/find-company/_slug/company-questions/_code/index.vue' /* webpackChunkName: "pages/portal/find-company/_slug/company-questions/_code/index" */))
const _be05df30 = () => interopDefault(import('../../../pages/portal/identity/_slug/match/_linkcode/index.vue' /* webpackChunkName: "pages/portal/identity/_slug/match/_linkcode/index" */))
const _75cb4872 = () => interopDefault(import('../../../pages/portal/additional-locations/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/additional-locations/_slug/_code/index" */))
const _b9bd33f2 = () => interopDefault(import('../../../pages/portal/advanced-documents/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/advanced-documents/_slug/_code/index" */))
const _250a8e11 = () => interopDefault(import('../../../pages/portal/agent/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/agent/_slug/_code/index" */))
const _4acf57cc = () => interopDefault(import('../../../pages/portal/authenticate/_slug/_code.vue' /* webpackChunkName: "pages/portal/authenticate/_slug/_code" */))
const _6086e302 = () => interopDefault(import('../../../pages/portal/authorised-representative/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/authorised-representative/_slug/_code/index" */))
const _7cc7c487 = () => interopDefault(import('../../../pages/portal/authorised-signatory/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/authorised-signatory/_slug/_code/index" */))
const _4b343950 = () => interopDefault(import('../../../pages/portal/club-manager/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/club-manager/_slug/_code/index" */))
const _262ffa8f = () => interopDefault(import('../../../pages/portal/company-principals/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/company-principals/_slug/_code/index" */))
const _2dc44c74 = () => interopDefault(import('../../../pages/portal/declaratory/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/declaratory/_slug/_code/index" */))
const _03bde77a = () => interopDefault(import('../../../pages/portal/designated-member/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/designated-member/_slug/_code/index" */))
const _3bc58f73 = () => interopDefault(import('../../../pages/portal/directors/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/directors/_slug/_code/index" */))
const _67c1d43f = () => interopDefault(import('../../../pages/portal/document-upload/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/document-upload/_slug/_code/index" */))
const _74a4a8bb = () => interopDefault(import('../../../pages/portal/entities/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/entities/_slug/_code/index" */))
const _7aa9888a = () => interopDefault(import('../../../pages/portal/forms/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/forms/_slug/_code/index" */))
const _2f32d94e = () => interopDefault(import('../../../pages/portal/id-verification/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/id-verification/_slug/_code/index" */))
const _104a9ed8 = () => interopDefault(import('../../../pages/portal/member/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/member/_slug/_code/index" */))
const _6512206c = () => interopDefault(import('../../../pages/portal/persons/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/persons/_slug/_code/index" */))
const _5d09b5a2 = () => interopDefault(import('../../../pages/portal/questionnaire/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/questionnaire/_slug/_code/index" */))
const _36cd1c04 = () => interopDefault(import('../../../pages/portal/secretary/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/secretary/_slug/_code/index" */))
const _8980cff4 = () => interopDefault(import('../../../pages/portal/syndicator/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/syndicator/_slug/_code/index" */))
const _7d7260a2 = () => interopDefault(import('../../../pages/portal/treasurer/_slug/_code/index.vue' /* webpackChunkName: "pages/portal/treasurer/_slug/_code/index" */))
const _6b52108c = () => interopDefault(import('../../../pages/portal/additional-locations/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/additional-locations/_slug/_code/create" */))
const _b8090266 = () => interopDefault(import('../../../pages/portal/agent/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/agent/_slug/_code/create" */))
const _4fec7008 = () => interopDefault(import('../../../pages/portal/authorised-representative/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/authorised-representative/_slug/_code/create" */))
const _43e51717 = () => interopDefault(import('../../../pages/portal/authorised-signatory/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/authorised-signatory/_slug/_code/create" */))
const _43073b6e = () => interopDefault(import('../../../pages/portal/club-manager/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/club-manager/_slug/_code/create" */))
const _70f8bbe2 = () => interopDefault(import('../../../pages/portal/company-principals/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/company-principals/_slug/_code/create" */))
const _157237a2 = () => interopDefault(import('../../../pages/portal/declaratory/_slug/_code/complete-portal.vue' /* webpackChunkName: "pages/portal/declaratory/_slug/_code/complete-portal" */))
const _2496724a = () => interopDefault(import('../../../pages/portal/designated-member/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/designated-member/_slug/_code/create" */))
const _64a0a9ab = () => interopDefault(import('../../../pages/portal/directors/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/directors/_slug/_code/create" */))
const _47a4b963 = () => interopDefault(import('../../../pages/portal/entities/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/entities/_slug/_code/create" */))
const _1f87ffc0 = () => interopDefault(import('../../../pages/portal/id-verification/_slug/_code/id-scan-complete.vue' /* webpackChunkName: "pages/portal/id-verification/_slug/_code/id-scan-complete" */))
const _2cd0b7d4 = () => interopDefault(import('../../../pages/portal/id-verification/_slug/_code/support.vue' /* webpackChunkName: "pages/portal/id-verification/_slug/_code/support" */))
const _2b2facaa = () => interopDefault(import('../../../pages/portal/member/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/member/_slug/_code/create" */))
const _091b5434 = () => interopDefault(import('../../../pages/portal/persons/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/persons/_slug/_code/create" */))
const _6aeaa18c = () => interopDefault(import('../../../pages/portal/secretary/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/secretary/_slug/_code/create" */))
const _57309910 = () => interopDefault(import('../../../pages/portal/syndicator/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/syndicator/_slug/_code/create" */))
const _e1711e22 = () => interopDefault(import('../../../pages/portal/treasurer/_slug/_code/create.vue' /* webpackChunkName: "pages/portal/treasurer/_slug/_code/create" */))
const _fe13e760 = () => interopDefault(import('../../../pages/portal/additional-locations/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/additional-locations/_slug/_code/_uuid/delete" */))
const _872aa722 = () => interopDefault(import('../../../pages/portal/additional-locations/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/additional-locations/_slug/_code/_uuid/edit" */))
const _32ca05d1 = () => interopDefault(import('../../../pages/portal/agent/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/agent/_slug/_code/_uuid/delete" */))
const _eb7ddba0 = () => interopDefault(import('../../../pages/portal/agent/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/agent/_slug/_code/_uuid/edit" */))
const _01826fc0 = () => interopDefault(import('../../../pages/portal/authorised-representative/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/authorised-representative/_slug/_code/_uuid/delete" */))
const _0e992bdf = () => interopDefault(import('../../../pages/portal/authorised-representative/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/authorised-representative/_slug/_code/_uuid/edit" */))
const _7daebe9b = () => interopDefault(import('../../../pages/portal/authorised-signatory/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/authorised-signatory/_slug/_code/_uuid/delete" */))
const _6fb1757a = () => interopDefault(import('../../../pages/portal/authorised-signatory/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/authorised-signatory/_slug/_code/_uuid/edit" */))
const _75e405b2 = () => interopDefault(import('../../../pages/portal/club-manager/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/club-manager/_slug/_code/_uuid/delete" */))
const _0deb9651 = () => interopDefault(import('../../../pages/portal/club-manager/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/club-manager/_slug/_code/_uuid/edit" */))
const _a471a0da = () => interopDefault(import('../../../pages/portal/company-principals/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/company-principals/_slug/_code/_uuid/delete" */))
const _cabc771c = () => interopDefault(import('../../../pages/portal/company-principals/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/company-principals/_slug/_code/_uuid/edit" */))
const _33048b5f = () => interopDefault(import('../../../pages/portal/designated-member/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/designated-member/_slug/_code/_uuid/delete" */))
const _46dba33e = () => interopDefault(import('../../../pages/portal/designated-member/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/designated-member/_slug/_code/_uuid/edit" */))
const _47f31032 = () => interopDefault(import('../../../pages/portal/entities/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/entities/_slug/_code/_uuid/delete" */))
const _6aff11c6 = () => interopDefault(import('../../../pages/portal/entities/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/entities/_slug/_code/_uuid/edit" */))
const _b3accc24 = () => interopDefault(import('../../../pages/portal/member/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/member/_slug/_code/_uuid/delete" */))
const _447dece6 = () => interopDefault(import('../../../pages/portal/member/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/member/_slug/_code/_uuid/edit" */))
const _46d01c10 = () => interopDefault(import('../../../pages/portal/persons/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/persons/_slug/_code/_uuid/delete" */))
const _0719dc17 = () => interopDefault(import('../../../pages/portal/persons/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/persons/_slug/_code/_uuid/edit" */))
const _b9871f04 = () => interopDefault(import('../../../pages/portal/secretary/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/secretary/_slug/_code/_uuid/delete" */))
const _7bb8441d = () => interopDefault(import('../../../pages/portal/secretary/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/secretary/_slug/_code/_uuid/edit" */))
const _7c08ce3c = () => interopDefault(import('../../../pages/portal/syndicator/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/syndicator/_slug/_code/_uuid/delete" */))
const _ea460d4a = () => interopDefault(import('../../../pages/portal/syndicator/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/syndicator/_slug/_code/_uuid/edit" */))
const _3727531a = () => interopDefault(import('../../../pages/portal/treasurer/_slug/_code/_uuid/delete.vue' /* webpackChunkName: "pages/portal/treasurer/_slug/_code/_uuid/delete" */))
const _2c232352 = () => interopDefault(import('../../../pages/portal/treasurer/_slug/_code/_uuid/edit.vue' /* webpackChunkName: "pages/portal/treasurer/_slug/_code/_uuid/edit" */))
const _a3f1428e = () => interopDefault(import('../../../pages/portal/directors/_slug/_code/_uuid/_directorType/delete.vue' /* webpackChunkName: "pages/portal/directors/_slug/_code/_uuid/_directorType/delete" */))
const _0f4f8518 = () => interopDefault(import('../../../pages/portal/directors/_slug/_code/_uuid/_directorType/edit.vue' /* webpackChunkName: "pages/portal/directors/_slug/_code/_uuid/_directorType/edit" */))
const _98d7b850 = () => interopDefault(import('../../../pages/portal/_slug/_code.vue' /* webpackChunkName: "pages/portal/_slug/_code" */))
const _dbb346e4 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/utility",
    component: _460777ab,
    name: "utility"
  }, {
    path: "/portal/down-for-maintenance",
    component: _56c81db4,
    name: "portal-down-for-maintenance"
  }, {
    path: "/portal/find-company/:slug",
    component: _3057b734,
    name: "portal-find-company-slug"
  }, {
    path: "/portal/my-companies/:slug",
    component: _963b7e12,
    name: "portal-my-companies-slug"
  }, {
    path: "/portal/find-company/:slug?/add",
    component: _c7df7896,
    name: "portal-find-company-slug-add"
  }, {
    path: "/portal/find-company/:slug?/confirmcompanyadded",
    component: _7415d377,
    name: "portal-find-company-slug-confirmcompanyadded"
  }, {
    path: "/portal/find-company/:slug?/declaration",
    component: _4ac7700e,
    name: "portal-find-company-slug-declaration"
  }, {
    path: "/portal/find-company/:slug?/faq",
    component: _bfafd8ac,
    name: "portal-find-company-slug-faq"
  }, {
    path: "/portal/find-company/:slug?/find-company-account-created",
    component: _18a12600,
    name: "portal-find-company-slug-find-company-account-created"
  }, {
    path: "/portal/find-company/:slug?/login",
    component: _4981fc40,
    name: "portal-find-company-slug-login"
  }, {
    path: "/portal/find-company/:slug?/select-business-type",
    component: _23020432,
    name: "portal-find-company-slug-select-business-type"
  }, {
    path: "/portal/find-company/:slug?/success-email",
    component: _b43d5e34,
    name: "portal-find-company-slug-success-email"
  }, {
    path: "/portal/find-company/:slug?/support",
    component: _7835b43a,
    name: "portal-find-company-slug-support"
  }, {
    path: "/portal/find-company/:slug?/verify",
    component: _a994d7d6,
    name: "portal-find-company-slug-verify"
  }, {
    path: "/portal/find-company/:slug?/login/resend",
    component: _4ee40a3d,
    name: "portal-find-company-slug-login-resend"
  }, {
    path: "/portal/find-company/:slug?/login/verify",
    component: _7f42b77b,
    name: "portal-find-company-slug-login-verify"
  }, {
    path: "/portal/find-company/:slug?/company-questions/:code",
    component: _912e525e,
    name: "portal-find-company-slug-company-questions-code"
  }, {
    path: "/portal/identity/:slug?/match/:linkcode",
    component: _be05df30,
    name: "portal-identity-slug-match-linkcode"
  }, {
    path: "/portal/additional-locations/:slug?/:code",
    component: _75cb4872,
    name: "portal-additional-locations-slug-code"
  }, {
    path: "/portal/advanced-documents/:slug?/:code",
    component: _b9bd33f2,
    name: "portal-advanced-documents-slug-code"
  }, {
    path: "/portal/agent/:slug?/:code",
    component: _250a8e11,
    name: "portal-agent-slug-code"
  }, {
    path: "/portal/authenticate/:slug?/:code?",
    component: _4acf57cc,
    name: "portal-authenticate-slug-code"
  }, {
    path: "/portal/authorised-representative/:slug?/:code",
    component: _6086e302,
    name: "portal-authorised-representative-slug-code"
  }, {
    path: "/portal/authorised-signatory/:slug?/:code",
    component: _7cc7c487,
    name: "portal-authorised-signatory-slug-code"
  }, {
    path: "/portal/club-manager/:slug?/:code",
    component: _4b343950,
    name: "portal-club-manager-slug-code"
  }, {
    path: "/portal/company-principals/:slug?/:code",
    component: _262ffa8f,
    name: "portal-company-principals-slug-code"
  }, {
    path: "/portal/declaratory/:slug?/:code",
    component: _2dc44c74,
    name: "portal-declaratory-slug-code"
  }, {
    path: "/portal/designated-member/:slug?/:code",
    component: _03bde77a,
    name: "portal-designated-member-slug-code"
  }, {
    path: "/portal/directors/:slug?/:code",
    component: _3bc58f73,
    name: "portal-directors-slug-code"
  }, {
    path: "/portal/document-upload/:slug?/:code",
    component: _67c1d43f,
    name: "portal-document-upload-slug-code"
  }, {
    path: "/portal/entities/:slug?/:code",
    component: _74a4a8bb,
    name: "portal-entities-slug-code"
  }, {
    path: "/portal/forms/:slug?/:code",
    component: _7aa9888a,
    name: "portal-forms-slug-code"
  }, {
    path: "/portal/id-verification/:slug?/:code",
    component: _2f32d94e,
    name: "portal-id-verification-slug-code"
  }, {
    path: "/portal/member/:slug?/:code",
    component: _104a9ed8,
    name: "portal-member-slug-code"
  }, {
    path: "/portal/persons/:slug?/:code",
    component: _6512206c,
    name: "portal-persons-slug-code"
  }, {
    path: "/portal/questionnaire/:slug?/:code",
    component: _5d09b5a2,
    name: "portal-questionnaire-slug-code"
  }, {
    path: "/portal/secretary/:slug?/:code",
    component: _36cd1c04,
    name: "portal-secretary-slug-code"
  }, {
    path: "/portal/syndicator/:slug?/:code",
    component: _8980cff4,
    name: "portal-syndicator-slug-code"
  }, {
    path: "/portal/treasurer/:slug?/:code",
    component: _7d7260a2,
    name: "portal-treasurer-slug-code"
  }, {
    path: "/portal/additional-locations/:slug?/:code?/create",
    component: _6b52108c,
    name: "portal-additional-locations-slug-code-create"
  }, {
    path: "/portal/agent/:slug?/:code?/create",
    component: _b8090266,
    name: "portal-agent-slug-code-create"
  }, {
    path: "/portal/authorised-representative/:slug?/:code?/create",
    component: _4fec7008,
    name: "portal-authorised-representative-slug-code-create"
  }, {
    path: "/portal/authorised-signatory/:slug?/:code?/create",
    component: _43e51717,
    name: "portal-authorised-signatory-slug-code-create"
  }, {
    path: "/portal/club-manager/:slug?/:code?/create",
    component: _43073b6e,
    name: "portal-club-manager-slug-code-create"
  }, {
    path: "/portal/company-principals/:slug?/:code?/create",
    component: _70f8bbe2,
    name: "portal-company-principals-slug-code-create"
  }, {
    path: "/portal/declaratory/:slug?/:code?/complete-portal",
    component: _157237a2,
    name: "portal-declaratory-slug-code-complete-portal"
  }, {
    path: "/portal/designated-member/:slug?/:code?/create",
    component: _2496724a,
    name: "portal-designated-member-slug-code-create"
  }, {
    path: "/portal/directors/:slug?/:code?/create",
    component: _64a0a9ab,
    name: "portal-directors-slug-code-create"
  }, {
    path: "/portal/entities/:slug?/:code?/create",
    component: _47a4b963,
    name: "portal-entities-slug-code-create"
  }, {
    path: "/portal/id-verification/:slug?/:code?/id-scan-complete",
    component: _1f87ffc0,
    name: "portal-id-verification-slug-code-id-scan-complete"
  }, {
    path: "/portal/id-verification/:slug?/:code?/support",
    component: _2cd0b7d4,
    name: "portal-id-verification-slug-code-support"
  }, {
    path: "/portal/member/:slug?/:code?/create",
    component: _2b2facaa,
    name: "portal-member-slug-code-create"
  }, {
    path: "/portal/persons/:slug?/:code?/create",
    component: _091b5434,
    name: "portal-persons-slug-code-create"
  }, {
    path: "/portal/secretary/:slug?/:code?/create",
    component: _6aeaa18c,
    name: "portal-secretary-slug-code-create"
  }, {
    path: "/portal/syndicator/:slug?/:code?/create",
    component: _57309910,
    name: "portal-syndicator-slug-code-create"
  }, {
    path: "/portal/treasurer/:slug?/:code?/create",
    component: _e1711e22,
    name: "portal-treasurer-slug-code-create"
  }, {
    path: "/portal/additional-locations/:slug?/:code?/:uuid?/delete",
    component: _fe13e760,
    name: "portal-additional-locations-slug-code-uuid-delete"
  }, {
    path: "/portal/additional-locations/:slug?/:code?/:uuid?/edit",
    component: _872aa722,
    name: "portal-additional-locations-slug-code-uuid-edit"
  }, {
    path: "/portal/agent/:slug?/:code?/:uuid/delete",
    component: _32ca05d1,
    name: "portal-agent-slug-code-uuid-delete"
  }, {
    path: "/portal/agent/:slug?/:code?/:uuid/edit",
    component: _eb7ddba0,
    name: "portal-agent-slug-code-uuid-edit"
  }, {
    path: "/portal/authorised-representative/:slug?/:code?/:uuid?/delete",
    component: _01826fc0,
    name: "portal-authorised-representative-slug-code-uuid-delete"
  }, {
    path: "/portal/authorised-representative/:slug?/:code?/:uuid?/edit",
    component: _0e992bdf,
    name: "portal-authorised-representative-slug-code-uuid-edit"
  }, {
    path: "/portal/authorised-signatory/:slug?/:code?/:uuid?/delete",
    component: _7daebe9b,
    name: "portal-authorised-signatory-slug-code-uuid-delete"
  }, {
    path: "/portal/authorised-signatory/:slug?/:code?/:uuid?/edit",
    component: _6fb1757a,
    name: "portal-authorised-signatory-slug-code-uuid-edit"
  }, {
    path: "/portal/club-manager/:slug?/:code?/:uuid?/delete",
    component: _75e405b2,
    name: "portal-club-manager-slug-code-uuid-delete"
  }, {
    path: "/portal/club-manager/:slug?/:code?/:uuid?/edit",
    component: _0deb9651,
    name: "portal-club-manager-slug-code-uuid-edit"
  }, {
    path: "/portal/company-principals/:slug?/:code?/:uuid?/delete",
    component: _a471a0da,
    name: "portal-company-principals-slug-code-uuid-delete"
  }, {
    path: "/portal/company-principals/:slug?/:code?/:uuid?/edit",
    component: _cabc771c,
    name: "portal-company-principals-slug-code-uuid-edit"
  }, {
    path: "/portal/designated-member/:slug?/:code?/:uuid?/delete",
    component: _33048b5f,
    name: "portal-designated-member-slug-code-uuid-delete"
  }, {
    path: "/portal/designated-member/:slug?/:code?/:uuid?/edit",
    component: _46dba33e,
    name: "portal-designated-member-slug-code-uuid-edit"
  }, {
    path: "/portal/entities/:slug?/:code?/:uuid/delete",
    component: _47f31032,
    name: "portal-entities-slug-code-uuid-delete"
  }, {
    path: "/portal/entities/:slug?/:code?/:uuid/edit",
    component: _6aff11c6,
    name: "portal-entities-slug-code-uuid-edit"
  }, {
    path: "/portal/member/:slug?/:code?/:uuid/delete",
    component: _b3accc24,
    name: "portal-member-slug-code-uuid-delete"
  }, {
    path: "/portal/member/:slug?/:code?/:uuid/edit",
    component: _447dece6,
    name: "portal-member-slug-code-uuid-edit"
  }, {
    path: "/portal/persons/:slug?/:code?/:uuid/delete",
    component: _46d01c10,
    name: "portal-persons-slug-code-uuid-delete"
  }, {
    path: "/portal/persons/:slug?/:code?/:uuid/edit",
    component: _0719dc17,
    name: "portal-persons-slug-code-uuid-edit"
  }, {
    path: "/portal/secretary/:slug?/:code?/:uuid/delete",
    component: _b9871f04,
    name: "portal-secretary-slug-code-uuid-delete"
  }, {
    path: "/portal/secretary/:slug?/:code?/:uuid/edit",
    component: _7bb8441d,
    name: "portal-secretary-slug-code-uuid-edit"
  }, {
    path: "/portal/syndicator/:slug?/:code?/:uuid/delete",
    component: _7c08ce3c,
    name: "portal-syndicator-slug-code-uuid-delete"
  }, {
    path: "/portal/syndicator/:slug?/:code?/:uuid/edit",
    component: _ea460d4a,
    name: "portal-syndicator-slug-code-uuid-edit"
  }, {
    path: "/portal/treasurer/:slug?/:code?/:uuid/delete",
    component: _3727531a,
    name: "portal-treasurer-slug-code-uuid-delete"
  }, {
    path: "/portal/treasurer/:slug?/:code?/:uuid/edit",
    component: _2c232352,
    name: "portal-treasurer-slug-code-uuid-edit"
  }, {
    path: "/portal/directors/:slug?/:code?/:uuid/:directorType?/delete",
    component: _a3f1428e,
    name: "portal-directors-slug-code-uuid-directorType-delete"
  }, {
    path: "/portal/directors/:slug?/:code?/:uuid/:directorType?/edit",
    component: _0f4f8518,
    name: "portal-directors-slug-code-uuid-directorType-edit"
  }, {
    path: "/portal/:slug?/:code?",
    component: _98d7b850,
    name: "portal-slug-code"
  }, {
    path: "/",
    component: _dbb346e4,
    name: "index"
  }, {
    path: "/portal/find-company/:slug?/:linkCode?",
    component: _3057b734,
    name: "portal-find-company-slug-code"
  }, {
    path: "/portal/find-company/:slug",
    component: _3057b734,
    name: "portal-find-company-slug"
  }, {
    path: "/portal/start-journey/:slug?/:customerReference?/:uuid?",
    component: _3057b734,
    name: "portal-find-company-slug-customer-reference"
  }, {
    path: "/portal/find-company-path/:slug?/:uuid?",
    component: _3057b734,
    name: "portal-find-company-path-slug-link"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
